import React from 'react';

const FullScreen = ({ children, results = [] }) => (
  <div className="w-100 min-vh-100 overflow-hidden-ns flex">
    <div className="v-mid w-100">{children}</div>
  </div>
);

export default FullScreen;



// WEBPACK FOOTER //
// ./src/components/FullScreen.js